export default defineNuxtPlugin(nuxtApp => {
  if (process.client) {
    inject('piniaStore', window.piniaStore = nuxtApp.$store || window.piniaStore || {})
  }
})
